import { useState } from "react";
import { Link } from "react-router-dom";
import { Page } from "../../../../components/page/page";
import { useLocalization } from "../../../../hooks/use-localization/useLocalization";
import { useUser } from "../../../../hooks/use-user/useUser";
import { Form } from "../../../../components/form/form";
import { StatusMessage } from "../../../../components/status-message/statusMessage";

export const Email: React.FC = () => {
  const [hasSubmitted, setHasSubmitted] = useState<boolean>(false);
  const { user } = useUser();
  const { localize } = useLocalization();

  if (!user) {
    return null;
  }

  return (
    <Page title={localize("email")}>
      {hasSubmitted ? (
        <StatusMessage type="success">
          {localize("admin:emailChanged")}
        </StatusMessage>
      ) : (
        <Form
          action="/change-email"
          method="POST"
          actionLabel={localize("save")}
          onSuccess={() => {
            setHasSubmitted(true);
          }}
        >
          <label>
            {localize("email")}
            <input
              type="text"
              name="email"
              defaultValue={user.email}
              autoComplete="email"
            />
          </label>
        </Form>
      )}
      <Link className="button secondary" to="../" relative="path">
        {localize("back")}
      </Link>
    </Page>
  );
};
